module.exports = {
    demo: false,
    brand: 'Epoints', // Footer brand
    appName: 'Epoints', // App Name
    showCredits: true, // Show credits in login page
    SOULMACHINE_API_KEY: "eyJzb3VsSWQiOiJkZG5hLXRhbWR0NC0tZXhwbG9yZXIiLCJhdXRoU2VydmVyIjoiaHR0cHM6Ly9kaC5zb3VsbWFjaGluZXMuY2xvdWQvYXBpL2p3dCIsImF1dGhUb2tlbiI6ImFwaWtleV92MV81ZmNmYmJiZi1kMGFhLTRlMjYtODI4MC0wNjQ3ZWU5OGJjNWMifQ==",
    url: 'https://chathub.epoints.vn', //https://chathub.epoints.vn,
}